"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRejectAction = exports.apiResolveAction = exports.apiCallApiAction = exports.apiIdleAction = void 0;
const api_enums_1 = require("../../../types/@enums/api.enums");
function apiIdleAction() {
    return { type: api_enums_1.ApiActionTypeEnum.IDLE };
}
exports.apiIdleAction = apiIdleAction;
function apiCallApiAction() {
    return { type: api_enums_1.ApiActionTypeEnum.CALL_API };
}
exports.apiCallApiAction = apiCallApiAction;
function apiResolveAction(payload) {
    return { type: api_enums_1.ApiActionTypeEnum.RESOLVED, payload };
}
exports.apiResolveAction = apiResolveAction;
function apiRejectAction(err) {
    return {
        type: api_enums_1.ApiActionTypeEnum.REJECTED,
        error: err instanceof Error ? err.message : String(err),
    };
}
exports.apiRejectAction = apiRejectAction;
